import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from "react";
import Head from 'next/head';
import { pagelink } from "@/config/site";
import { _postURL } from "@/api/index";
import { toast } from "@/libraries/swal";
import { Breadcrumb } from '../../../components/section/breadcrumb';
import Subscription from "@/components/section/subscription";
import _ from 'lodash';
import { TextInput } from '@mantine/core';
import { BiSearch } from "react-icons/bi";
import { Link } from "@/helpers/common_helper";
import { useMediaQuery } from '@mantine/hooks';

let ApiData = [
    {companyId: 1, companyName: "MAXIM88", imagePath: "/assets/images/company-logo/companylogo_1.png", amount: 4125, totalComplaint: 4, lastComplaintDate: "01/08/2022"},
    {companyId: 2, companyName: "BK8", imagePath: "/assets/images/company-logo/companylogo_2.png", amount: 3817, totalComplaint: 4, lastComplaintDate: "15/07/2022"},
    {companyId: 3, companyName: "ECLBET", imagePath: "/assets/images/company-logo/companylogo_3.png", amount: 3650, totalComplaint: 3, lastComplaintDate: "21/06/2022"},
    {companyId: 4, companyName: "ME88", imagePath: "/assets/images/company-logo/companylogo_4.png", amount: 3132, totalComplaint: 3, lastComplaintDate: "18/06/2022"},
    {companyId: 5, companyName: "BETSUPER", imagePath: "/assets/images/company-logo/companylogo_5.png", amount: 3094, totalComplaint: 3, lastComplaintDate: "15/06/2022"},
    {companyId: 6, companyName: "MAXIM88", imagePath: "/assets/images/company-logo/companylogo_1.png", amount: 4125, totalComplaint: 4, lastComplaintDate: "01/08/2022"},
    {companyId: 7, companyName: "BK8", imagePath: "/assets/images/company-logo/companylogo_2.png", amount: 3817, totalComplaint: 4, lastComplaintDate: "15/07/2022"},
    {companyId: 8, companyName: "ECLBET", imagePath: "/assets/images/company-logo/companylogo_3.png", amount: 3650, totalComplaint: 3, lastComplaintDate: "21/06/2022"},
    {companyId: 9, companyName: "ME88", imagePath: "/assets/images/company-logo/companylogo_4.png", amount: 3132, totalComplaint: 3, lastComplaintDate: "18/06/2022"},
    {companyId: 10, companyName: "BETSUPER", imagePath: "/assets/images/company-logo/companylogo_5.png", amount: 3094, totalComplaint: 3, lastComplaintDate: "15/06/2022"},
]

export default function Index(props) {
    const { t, session } = props;
    const [offset, setOffset] = useState(0);
    const [loadMore, setLoadMore] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);
    const [casinoList, setCasinoList] = useState([]);
    const [totalRow, setTotalRow] = useState(0);
    const [userLogin, setUserLogin] = useState(false);
    const limit = 10;

    const is1600 = useMediaQuery('(max-width:1600px)');
    const isMobileView = useMediaQuery('(max-width:1199px)');

    const currentPage = {
        pageName: t('Complaint'),
        pageLink: pagelink.review.complaint
    };

    const previousPage = [{
        pageName: t('Review'),
        pageLink: pagelink.review.homepage
    }];

    const _here = (value) => {
        console.log(value);
    }

    const _getNextComplaintList = async (offset, limit = limit) => {
        setIsProcessing(true);
        setOffset(offset);
        let req = {
            "limit": limit,
            "offset": offset
        }
        let result = await _postURL("/api/complaint/total", {...req});
        if(offset < totalRow){
            setLoadMore(false);
        }
        setCasinoList([...casinoList, ...result.data.data]);
        setIsProcessing(false);
    }

    useEffect(async ()=>{
        let memberData = (session && session.user != null) ? session.user.member : '';
        if(!_.isEmpty(memberData)){
            setUserLogin(true);
        }
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            // fetch data
            let req = {
                "limit": limit,
                "offset": offset
            }
            let result = await _postURL("/api/complaint/total", {...req});
            setTotalRow(result.data.total_row);
            setCasinoList(result.data.data);
        }
        catch (error) {
            toast.error(error);
        }
    }

    const handleEnterKeyPress = (event) => {
        if(event.key === 'Enter'){
            _submitSearch(searchValue);
        }
    }

    const _submitSearch = (value) =>{
        if(value.length > 0 && value != ""){
            let casinoListSearch = []

            // take exist data get
            casinoListSearch = casinoList.filter((casinoList) =>
                casinoList.display_name.toLowerCase().includes(value.toLowerCase())
            )
            if(casinoListSearch.length < limit){
                console.log(casinoListSearch);
                // if exist data less then limit call api
                casinoListSearch = casinoList.filter((casinoList) =>
                    casinoList.display_name.toLowerCase().includes(value.toLowerCase())
                )
            }
            setCasinoList(casinoListSearch);
        } else {
            // call api get data 
            fetchData();
        }
    }
    
    return(
        <>
            <Head>
                <title>{t('Complaint')} | {t('Site_name')}</title>
                <meta name="title" content=""></meta>
                <meta itemProp="title" content=""></meta>
                <meta property="og:title" content=""></meta>
                <meta name="description" content=""></meta>
                <meta itemProp="description" content=""></meta>
                <meta property="og:description" content=""></meta>
                <meta name="keywords" content=""></meta>
            </Head>
            <div className="page-content pt-5">
                <div className='custom_container2'>
                    <Breadcrumb 
                        props={ props }
                        currentPage={ currentPage }
                        previousPage={ previousPage }
                    />
                    <div className="general-box">
                        <h1>{t('Complaint')}</h1>
                        <p>
                            We hope to guide you AWAY from bad platforms. If you have experienced something that looks 
                            suspicious or illegal, you can submit a complaint to us in confidence.
                            <br /><br />Please make sure you have submitted your personal information and any supporting evidence to 
                            support your complaints. You may also email us to lodge complaints.We will investigate the 
                            complaint and contact you for further complaint discussion.
                        </p>
                    </div>
                </div>
                <section className='custom_container2'>
                    <div className='complaintList-page-complaint-button-row'>
                        {userLogin ? 
                        <Link href={pagelink.review.submitComplaint}>
                            <div className='complaintList-page-complaint-button'>
                                <h3 className='custom_h3 custom_colorWhite'>
                                    {t('Submit_complaint')}
                                </h3>
                            </div>
                        </Link> 
                        : 
                        <Link href={pagelink.authentication.login}>
                            <div className='complaintList-page-complaint-button'>
                                <h3 className='custom_h3 custom_colorWhite'>
                                    {t('Submit_complaint')}
                                </h3>
                            </div>
                        </Link>
                        }
                    </div>
                    <div className='complaintList-page-complaint-search-row'>
                        <div className='complaintList-page-complaint-search'>
                            <TextInput
                                type={"name"}
                                name="search"
                                placeholder="Search"
                                rightSection={<BiSearch onClick={()=>{_submitSearch(searchValue)}} className='complaintList-page-complaint-search-input-icon'/>}
                                classNames={{
                                    input: "complaintList-page-complaint-search-input",
                                    rightSection: "complaintList-page-complaint-search-input-rightSection"
                                }}
                                value={searchValue} 
                                onChange={(event)=>{setSearchValue(event.currentTarget.value)}}
                                onKeyPress={handleEnterKeyPress}
                            />
                        </div>
                    </div>
                    <div className='complaintList-page-list'>
                        {
                            _.reduce(casinoList, (result, value, key) => {
                                result.push(
                                    <div key={key} className='complaintList-page-item'>
                                        <div className='complaintList-page-item-image'>
                                            <img src={`${process.env.NEXT_PUBLIC_FS_URL}${value.logo}`} alt="" className="img-fluid w-100" />
                                        </div>
                                        <div className='complaintList-page-item-content'>
                                            <div className="complaintList-page-item-topContent" >
                                                <div className='complaintList-page-item-top'>
                                                    <div>
                                                        <h3 className='custom_h3'>
                                                            {value.display_name}
                                                        </h3>
                                                    </div>
                                                </div>
                                                <div className='complaintList-page-item-center'>
                                                    <div className='complaintList-page-item-left'>
                                                        {/* <p className='custom_p'>
                                                            Disputed amount: <strong>RM{value.amount}</strong>
                                                        </p> */}
                                                        <p className='custom_p'>
                                                            Total Complaints: <strong>({value.total_complaint})</strong>
                                                        </p>
                                                    </div>
                                                    <div className='complaintList-page-item-right'>
                                                        <Link href={pagelink.review.complaint+'/'+value.link}>
                                                            <div className='complaintList-page-item-right-button'>
                                                                <h4 className='custom_h4 custom_colorWhite'>
                                                                    {t('View_all')}
                                                                </h4>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='complaintList-page-item-bottomContent'>
                                                <p className={isMobileView == true ? 'custom_p3' : is1600 == true ? 'custom_p2' : 'custom_p'}>
                                                    Last complaint received on : {value.max_date}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                                return result;
                            }, [])
                        }
                    </div>
                    <div className=''>
                        <div className="more-history" style={{ display: loadMore ? '' : 'none' }}>
                            <a onClick={() => { _getNextComplaintList(offset + limit, limit) }} style={{ cursor: 'pointer' }}>
                                <img src="/assets/images/double-down-arrow.png" alt="" className="img-fluid" />{t('Load_more')}
                            </a>
                        </div>
                    </div>
                </section>
            </div>

            {/** Subscription Part */}
            <Subscription {...props}/>
        </>
    )
}

export async function getStaticProps(data) {
    // return { notFound: true };  // force it to 404
    return {
        props: {
            ...(await serverSideTranslations(data.locale, ['common'])),
        },
    };
}